import { Box, Typography, ImageList, ImageListItem, useMediaQuery } from "@mui/material";
import bg from '../assets/images/about-us-2.png';
import img1 from '../assets/images/Opening.jpeg';
import img2 from '../assets/images/Openingceremoneyimgtkstrust.jpeg';
import img3 from '../assets/images/Openingceremonytkstrust.jpeg';
import img4 from '../assets/images/g1.jpeg';
import img5 from '../assets/images/g2.jpeg';
import img6 from '../assets/images/g3.jpeg';
import img7 from '../assets/images/g4.jpeg';
import img8 from '../assets/images/g5.jpeg';
import Slider1 from '../assets/images/Sirkazhi_Temple_2.jpeg';
import Slider2 from '../assets/images/Slider-images-TSCT1.jpg';
import Slider3 from '../assets/images/Thirukadaiyur-Temple1-TKSTrust.jpg';
import Slider4 from '../assets/images/cwa temple croped.png';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
const images = [Slider1, Slider2, Slider3,  Slider4];

const itemData = [
  { img: img1, title: "Image 1" },
  { img: img2, title: "Image 2" },
  { img: img3, title: "Image 3" },
  { img: img4, title: "Image 4" },
  { img: img5, title: "Image 5" },
  { img: img6, title: "Image 6" },
  { img: img7, title: "Image 7" },
  { img: img8, title: "Image 8" },
];


function App() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:1024px)");
  const cols = isMobile ? 1 : isTablet ? 2 : 4;
  return (
    <Box>
      {/* Hero Banner*/}
      <Box
  sx={{
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center top 10%", // Moves the image down by 10%
    height: "80vh",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "white",
    position: "relative",
  }}
>
        {/* Overlay to improve readability */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          }}
        />


        <Typography variant="h2" sx={{ fontWeight: "bold", zIndex: 1, color: "#FFCC03" }}>
          Gallery
        </Typography>


        <Typography variant="h5" sx={{ fontWeight: "bold", zIndex: 1, marginTop: 2, color: "white" }}>
          Capturing our journey, milestones, and achievements.
        </Typography>
      </Box>


      {/* Our People section */}
      <Box sx={{ backgroundColor: "#f8f9e9", py: 6, textAlign: "center" }}>
        <Typography variant="h3" sx={{ fontWeight: "bold", color: "#E52029", fontSize: "34px" }}>
          Opening <span style={{ color: "#FAD707" }}>Ceremony</span>
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontSize: "16px",
            color: "#000000",
            lineHeight: 1.8,
            fontWeight: "600",
            fontSize: "16px",
            textAlign: "center",
            px: { xs: 2, sm: 6, md: 9 },
          }}
          gutterBottom
        >
          Highlights from Thirukadaiyur Senaithalaivar Charitable Trust<br />
          Uniting Creativity, Celebrating Ceremony 🎨✨
        </Typography>
      </Box>


      {/* Image Section */}
      <Box 
      sx={{ 
        backgroundColor: "#f8f9e9", 
        py: 4, 
        display: "flex", 
        justifyContent: "center", 
        px: { xs: 2, sm: 4, md: 0 } // Add margin for mobile
      }}
    >
      <ImageList 
        sx={{ width: "100%", maxWidth: 1200, height: "auto" }} 
        cols={cols} 
        gap={10}
      >
        {itemData.map((item) => (
          <ImageListItem key={item.img}>
            <img
              src={item.img}
              alt={item.title}
              loading="lazy"
              style={{ 
                borderRadius: "8px", 
                width: "100%", 
                height: "330px", // Ensuring all images have the same height
                objectFit: "cover" // Ensuring aspect ratio is maintained
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>
      </Box>
        <Box sx={{ backgroundColor: "#f8f9e9", py: 6, textAlign: "center" }}>
          <Typography variant="h3" sx={{ fontWeight: "bold",fontSize: "60px", color: "#E52029", fontSize: "34px" }}>
            Photo <span style={{ color: "#FAD707" }}> Gallery</span>
          </Typography>
          </Box>

          {/* Swiper Image Slider */}
          <div className="bg-[#f8f9e9] py-10 px-4 md:px-0">
    <div className="max-w-5xl mx-auto mt-6 relative">
      <Swiper
        spaceBetween={20}
        slidesPerView={2}
        navigation={{
          prevEl: ".custom-prev",
          nextEl: ".custom-next"
        }}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      loop={true}
      modules={[Navigation, Autoplay]}
      breakpoints={{
        0: { slidesPerView: 1, spaceBetween: 10 },
        768: { slidesPerView: 2, spaceBetween: 20 },
      }}
    >
      {images.map((img, index) => (
        <SwiperSlide key={index} className="px-2 md:px-0">
          <img
            src={img}
            alt={`Image ${index + 1}`}
            className="w-full h-[300px] object-cover rounded-lg shadow-lg"
          />
        </SwiperSlide>
      ))}
    </Swiper>

    {/* Custom Navigation Buttons */}
    <button
  className="custom-prev"
  style={{
    position: "absolute",
    top: "50%",
    left: "-20px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❮
</button>

<button
  className="custom-next"
  style={{
    position: "absolute",
    top: "50%",
    right: "-20px",
    transform: "translateY(-50%)",
    background: "transparent", // Transparent background
    color: "black",
    padding: "10px",
    borderRadius: "50%",
    zIndex: 10,
    border: "none", // Remove border if needed
    cursor: "pointer",
    fontSize: "20px",
  }}
>
  ❯
</button>
  </div>
</div>




    </Box>
  );
}


export default App;